export const trimMultipleWhiteSpaces = (str: string): string => str.replace(/\s+/g, ' ');
export const capitalize = (str: string): string =>
  str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
